import { api } from './customers'

export interface CustomerBloodAppointment {
    id: number
    customerId: number
    bloodTestDate: string
    bloodTestTime: string
}

type CustomerBloodAppointmentsResponse = CustomerBloodAppointment[]


export const CustomerBloodAppointmentApi = api.injectEndpoints({
    endpoints: (build) => ({
        getCustomerBloodAppointments: build.query<CustomerBloodAppointmentsResponse, void>({
            query: () => 'blood_test_collections',
            providesTags: (result) =>
                result
                    ? [
                        ...result["data"]?.map(({ id }) => ({ type: 'CustomerBloodAppointment' as const, id })),
                        { type: 'CustomerBloodAppointment', id: 'LIST' },
                    ]
                    : [{ type: 'CustomerBloodAppointment', id: 'LIST' }],
        }),
        addCustomerBloodAppointment: build.mutation<CustomerBloodAppointment, Partial<CustomerBloodAppointment>>({
            query: (body) => ({
                url: `blood_test_collections`,
                method: 'POST',
                body,
            }),
            transformResponse: (response: { data: CustomerBloodAppointment }, meta, arg) => response.data,
        }),
        getCustomerBloodAppointment: build.query<CustomerBloodAppointment, string>({
            query: (id) => `blood_test_collections/${id}`,
            transformResponse: (response: { data: CustomerBloodAppointment }, meta, arg) => response.data,
        }),
        getCustomerBloodAppointmentByCustomerId: build.query<CustomerBloodAppointment[], string>({
            query: (id) => `get_appointmentBycustomerID/${id}`,
            transformResponse: (response: { data: CustomerBloodAppointment[] }, meta, arg) => response.data,
        }),
        updateCustomerBloodAppointment: build.mutation<void, Pick<CustomerBloodAppointment, 'id'> & Partial<CustomerBloodAppointment>>({
            query: ({ id, ...patch }) => ({
                url: `blood_test_collections/${id}`,
                method: 'PUT',
                body: patch,
            }),
        }),
        deleteCustomerBloodAppointment: build.mutation<{ success: boolean; id: number }, number>({
            query(id) {
                return {
                    url: `blood_test_collections/${id}`,
                    method: 'DELETE',
                }
            },
        }),
    }),
})

export const {
    useGetCustomerBloodAppointmentQuery,
    useGetCustomerBloodAppointmentsQuery,
    useGetCustomerBloodAppointmentByCustomerIdQuery,
    useAddCustomerBloodAppointmentMutation,
    useUpdateCustomerBloodAppointmentMutation,
    useDeleteCustomerBloodAppointmentMutation,
} = CustomerBloodAppointmentApi

